import {Component, OnInit} from '@angular/core';
import {RegistriesService} from '../../service';
import {ActivatedRoute, Router} from '@angular/router';
import {AccessJson} from "@amlCore/models";
import {RegistriesAccessEnum} from "@amlCore/enums";
import {TableService, UserService, VisitedService} from "@amlCore/services";
import {Utils} from "@amlCore/utils";
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {IDataResponse} from "@amlCore/interfaces";
import {ConsolidatedFilter} from "../../../core/models/consolidatedFilter.model";
import {ConsolidatedSubjectList} from "../../model/consolidated/consolidatedSubjectList.model";


@Component({
  selector: 'app-registry-consolidated-list',
  templateUrl: './consolidated-list.component.html'
})
export class ConsolidatedListComponent extends TableReactiveUrlController implements OnInit {

  isShowVisited = true;

  constructor(private regSrv: RegistriesService,
              private userSrv: UserService,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router) {
    super(router, activatedRoute, visitedService, tableService, {sort: 'idSubject', dir: 'ASC', filter: new ConsolidatedFilter()});
  }

  public dataList: ConsolidatedSubjectList[] = [];
  public isAll = true;
  public access: AccessJson;
  public goBack = Utils.goBack;
  private id: string;
  protected language: string;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_CONSOLIDATED);
    this.activatedRoute.params.subscribe(params => {
      this.id = params.id;
      this.language = params.language;
      this.activatedRoute.queryParams.subscribe(data => {
        this.isAll = !this.id;
        const paramsData = this.syncParams(data);
        paramsData.id = this.id;
        this.loadList(paramsData);
      });
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data: ConsolidatedFilter) {
    const filter = this.tableService.getFilterSubject(data) as ConsolidatedFilter;
    return this.getFilterPlanObject(filter);
  }

  public onPageChange(params: ConsolidatedFilter): void {
    const filter = this.getParams({...params, ...this.filter}) as ConsolidatedFilter;
    filter['isAll'] = this.isAll;
    this.navigate(filter);
  }

  public onSearch(): void {
    const params = this.getSearchPage(this.filter) as ConsolidatedFilter;
    this.onPageChange(params);
  }

  private loadList(params?: ConsolidatedFilter): void {
    this.regSrv.getConsolidatedList(this.getParams(params)).subscribe((data: IDataResponse<ConsolidatedSubjectList>) => {
      this.dataList = data.content;
      this.total = data.totalSize;
    });
  }

  public getVersion(): String {
    if(!this.language) return "";
    return `(${this.language == 'ru' ? 'русскоязычная':'англоязычная'} версия)`;
  }
}
